var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<div class=\"row\"> <form name=\"twoStepCreateForm\" ng-submit=\"pay.createPayment()\" novalidate> <payment-groups ng-if=\"pay.checkFields.length && pay.checkFields[0].type == 'GROUP'\" groups=\"pay.checkFields\" step=\"create\"></payment-groups> <payment-fields ng-if=\"pay.checkFields.length && pay.checkFields[0].type != 'GROUP'\" fields=\"pay.checkFields\"></payment-fields>                                                                                 </form> </div>";
ngModule.run(["$templateCache",function(c){c.put("paymentCreate/templates/yasno.html",v1)}]);
module.exports=v1;


/*****************
 ** WEBPACK FOOTER
 ** ./app/directives/paymentCreate/templates/yasno.html
 ** module id = 566
 ** module chunks = 1
 **/